import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { Box, StackSection } from "@origin-digital/ods-core";
import { useArticle } from "../../hooks/useArticle";
import { ContentSection } from "./layout/ContentSection/ContentSection";
import mapBreadcrumbs from "../../helpers/breadcrumbsMapper";
import { PageTemplate } from "../PageTemplate/PageTemplate";
import { NeedHelp } from "src/components/NeedHelp";

const FDV_PATH_SEGMENT = "family-and-domestic-violence";

const isFdvUrl = (
  categoryUri: string | undefined,
  subcategoryUri: string | undefined
): boolean =>
  [categoryUri, subcategoryUri].some((segment) =>
    segment?.includes(FDV_PATH_SEGMENT)
  );

export const ArticlePage: React.FC = () => {
  const { categoryUri, subcategoryUri, slug } = useParams<{
    categoryUri: string;
    subcategoryUri: string;
    slug: string;
  }>();
  const { data, loading } = useArticle(slug);
  const article = data?.data?.article;

  const formattedBreadcrumbs = useMemo(
    () => mapBreadcrumbs(article?.breadcrumbs),
    [article]
  );

  const isFdvArticle = isFdvUrl(categoryUri, subcategoryUri);

  return (
    <PageTemplate
      data-id="help-article-page"
      metadata={{
        title: article?.seo.title,
        description: article?.seo.description,
      }}
    >
      <StackSection
        hideGutter={{ xs: true, sm: false }}
        data-id="article-page"
        width="xlarge"
        space="none"
        paddingY="none"
        backgroundColor="cardBackground"
      >
        <ContentSection
          breadcrumbs={formattedBreadcrumbs}
          isLoading={loading}
          body={article?.body || ""}
          title={article?.title || ""}
          isFdvArticle={isFdvArticle}
        />

        <Box marginY="xxlarge">
          <NeedHelp />
        </Box>
      </StackSection>
    </PageTemplate>
  );
};
